import GraphModal from 'graph-modal';

export const form = () => {
    const form = document.querySelector(".footer__bid-inner");
    if (!form) return;

    const inputs = form.querySelectorAll("input[required], textarea[required]");
    const telInput = form.querySelector("#tel");
    const checkbox = form.querySelector("#politic");
    const submitBtn = form.querySelector(".footer__bid-btn");
    const modal = new GraphModal();
    const interestCheckboxes = form.querySelectorAll(".footer__bid-checkboxes-input");

    const formChecks = form.querySelectorAll(".footer__bid-checkboxes-input");
    const advChecks = document.querySelectorAll(".advertising-section__actions-input");

    function syncCheckboxes(source, target) {
        source.forEach(src => {
            src.addEventListener("change", () => {
                target.forEach(trg => {
                    if (trg.value === src.value) {
                        trg.checked = src.checked;
                    }
                });
            });
        });
    }

    syncCheckboxes(formChecks, advChecks);
    syncCheckboxes(advChecks, formChecks);


    function validateForm() {
        let isValid = true;

        inputs.forEach((input) => {
            if (input.value.trim() === "") {
                isValid = false;
            }
        });

        const phoneDigits = telInput.value.replace(/\D/g, "");
        if (phoneDigits.length < 10) {
            isValid = false;
        }

        if (!checkbox.checked) {
            // isValid = false;
            checkbox.classList.add("invalid");
        } else {
            checkbox.classList.remove("invalid");

        }
        let hasInterest = false;

        interestCheckboxes.forEach((ch) => {
            if (ch.checked) hasInterest = true;
        });

        if (!hasInterest) {
            isValid = false;
        }

        submitBtn.disabled = !isValid;
    }

    form.addEventListener("input", validateForm);
    form.addEventListener("change", validateForm);

    form.addEventListener("submit", (e) => {
        e.preventDefault();
        validateForm();
        if (submitBtn.disabled) return;


        // const formData = {
        //     name: form.querySelector('input[placeholder="Ваше имя*"]').value.trim(),
        //     company: form.querySelector('input[placeholder="Компания*"]').value.trim(),
        //     phone: telInput.value.trim(),
        //     email: form.querySelector('input[type="email"]').value.trim(),
        //     comment: form.querySelector("textarea").value.trim(),
        //     interests: [...interestCheckboxes]
        //         .filter(ch => ch.checked)
        //         .map(ch => ch.value),
        //     accept: checkbox.checked
        // };
        // console.log(formData)

        // try {
        //     const response = await fetch("/send-form", {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json"
        //         },
        //         body: JSON.stringify(formData)
        //     });
        //
        //     if (!response.ok) {
        //         throw new Error("Network response was not ok");
        //     }
        //
        //     const result = await response.json();
        //     console.log("Успешно отправлено:", result);
        //
        // } catch (error) {
        //     console.error("Ошибка отправки:", error);
        // }
        let formData = new FormData(form);

        form.reset();
        submitBtn.disabled = true;
        
        fetch(form.getAttribute('action'), {
            method: 'POST',
            body: formData
        }).then(response => response.json())
            .then(response => {
                if (response.success) {
                    modal.open("thanks");
                    setTimeout(() => {
                        modal.close();
                    }, 5000);
                }
            }).catch(error => {
                console.error(error);
            })
    });
};
